// extracted by mini-css-extract-plugin
export var link = "_uv-0";